import React, { useEffect, useState } from "react";
import { AnimatePresence, m } from "framer-motion";
import Header from "../../../components/Header";
import Cookies from "universal-cookie";
import BreadCrumb from "../../../components/BreadCrumb";
import { container, item } from "../RecruitmentDashBoard/constants";
import { message, Pagination, Table } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useQuery } from "react-query";
import CVParsingFilter from "./cvParsingFilter";
import jwtDecode from "jwt-decode";
import "./cvParsing.css";
import { useTranslation } from "react-i18next";

const RecruitmentLogs = ({language,changeLanguage}) => {
  const {t} = useTranslation();
  const cookies = new Cookies();
  const token = cookies.get("token");
  const user = token && jwtDecode(token);
  var localizedFormat = require("dayjs/plugin/localizedFormat");
  dayjs.extend(localizedFormat);
  // const [name, setName] = useState("");
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({
    search: "",
    JobCategory: "",
    Age: "",
    JobTitle: "",
    Nationality: "",
    Gender: "",
    MaritalStatus: "",
    FromDate: "",
    ToDate: "",
  });
  const [isFilterModal, toggleFilterModal] = useState(false);

  useEffect(() => {
    document.title = "Recruitment - Logs";
    refetch(filter);
    // eslint-disable-next-line
  }, []);

  const refetch = (values) => {
    getData(values, page);
  };

  const navigation = [
    { id: 0, name: t("dashboard"), url: "/recruitment/dashboard" },
    {
      id: 1,
      name: t("logs"),
      active: true,
    },
  ];

  const onChange = (page) => {
    setPage(page);
    getData(filter, page);
  };

  const getData = async (values, page) => {
    setLoading(true);
    setData([]);
    let config = {
      headers: {
        Authorization: token,
      },
    };
    try {
      const Data = await axios.get(
        `/api/logs?recruitmentId=${user?.recruitmentId}&page=${page}`,
        config
      );
      if (Data.status === 200) {
        setLoading(false);
        setData(Data.data.data);
        setTotal(Data.data.TotalDisplay);
      } else {
        if (Data.status === 201) {
          message.error(Data.data.error);
          setLoading(false);
        } else {
          message.error("Ouch, Something Went Terribly Wrong!");
          setLoading(false);
        }
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: t("date"),
      render: (record) => (
        <div className="text-grey">{dayjs(record.createdAt).format("ll")}</div>
      ),
    },
    {
      title: t("title"),
      render: (record) => <div className="text-grey">{record.text}</div>,
    },
    {
      title: t("user"),
      render: (record) => (
        <div>
          <div className="text-black bold">{record.name}</div>
          <div className="very-small-text text-grey bold">{record.email}</div>
        </div>
      ),
    },
  ];

  const { data: nationalityResult } = useQuery(
    ["nationality"],
    () => axios.get("https://cvapi.muscatwave.com/api/nationality"),
    {
      refetchOnWindowFocus: false,
      select: (data) => {
        const newData = data.data.data.map((item) => ({
          label: `${!item.nationality ? "None" : item.nationality} - (${
            !item.nationality ? "All" : item.cnt
          })`,
          value: item.nationality,
        }));
        return newData;
      },
    }
  );

  const { data: jobCategoryResult } = useQuery(
    ["category"],
    () => axios.get("https://cvapi.muscatwave.com/api/category"),
    {
      refetchOnWindowFocus: false,
      select: (data) => {
        const newData = data.data.data.map((item) => ({
          label: `${!item.category ? "None - (All)" : item.category}${
            item.category && `(${item.cnt})`
          }`,
          value: `${!item.category ? "" : item.category}`,
        }));
        newData.shift();
        return newData;
      },
    }
  );

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      {/* {isModalOpen && (
        <RecruitmentInterviewsForm
          isModalOpen={isModalOpen}
          setModal={toggleModal}
          editData={editData}
          setEditData={setEditData}
          getData={refetch}
          clientsList={clientsList}
          clientFetching={clientFetching}
          jobsList={jobsList}
          jobFetching={jobFetching}
          filter={filter}
        />
      )} */}
      {/* <Modal
        title="Delete Confirmation"
        open={deleteModal}
        onOk={deleteData}
        onCancel={handleCancel}
        okText={"Delete"}
        okType={"danger"}
        confirmLoading={deleteLoading}
      >
        <p>{`Are you sure you want to delete "${deletionData?.candidate}" from interview data?`}</p>
      </Modal> */}
      <Header
        home={"/recruitment/dashboard"}
        logOut={"/recruitment"}
        language={language}
        changeLanguage={changeLanguage}
      />
      <m.div
        className="recruitment-contacts"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <m.div className="title-text primary-color" variants={item}>
          {t("resumes")}
        </m.div>
        <m.div
          className="recruitment-filter-nav-header-without"
          variants={item}
        >
          <BreadCrumb items={navigation} />
          <div className="flex-small-gap">
            {/* <form
              onSubmit={(e) => {
                e.preventDefault();
                setFilter({
                  ...filter,
                  search: name,
                });
                refetch({
                  search: name,
                  JobCategory: filter?.JobCategory || "",
                  Age: filter?.Age || "",
                  JobTitle: filter?.JobTitle || "",
                  Nationality: filter?.Nationality || "",
                  Gender: filter?.Gender || "",
                  MaritalStatus: filter?.MaritalStatus || "",
                  FromDate: filter?.FromDate || "",
                  ToDate: filter?.ToDate || "",
                });
              }}
            >
              <Input
                placeholder="Search"
                prefix={<AiOutlineSearch className="large-text" />}
                size="large"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <Button className="hidden" htmlType="submit">
                Search
              </Button>
            </form>
            <Button
              type="primary"
              size="large"
              onClick={() => {
                toggleFilterModal(true);
              }}
              className={checkFilterActive(filter) && "filter-button--active"}
            >
              <FaFilter className="medium-text" />
            </Button> */}
            {/* <Button
              type="primary"
              size="large"
              onClick={() => {
                setEditData(null);
                toggleModal(true);
              }}
            >
              + Create
            </Button> */}
          </div>
        </m.div>
        <AnimatePresence>
          {isFilterModal && (
            <CVParsingFilter
              isFilterModal={isFilterModal}
              toggleFilterModal={toggleFilterModal}
              filterData={filter}
              setFilterData={setFilter}
              getData={refetch}
              loading={isLoading}
              nationalityResult={nationalityResult}
              jobCategoryResult={jobCategoryResult}
            />
          )}
        </AnimatePresence>
        <m.div variants={item}>
          <Table
            dataSource={data}
            columns={columns}
            loading={isLoading}
            pagination={false}
            rowKey={"id"}
          />
          <div className="pagination">
            <div className="pagination-total">{`Showing ${
              page === 1 ? 1 : page * 10 - 10 + 1
            } to ${page * 10 > total ? total : page * 10} of ${total}`}</div>
            <Pagination
              current={page}
              onChange={onChange}
              total={total}
              showSizeChanger={false}
            />
          </div>
        </m.div>
      </m.div>
    </m.div>
  );
};

export default RecruitmentLogs;
